import React from "react";
import classes from "./Partners.module.css";

// import Annie from "../../../assets/tools/App-Annie.jpg";
// import Buffers from "../../../assets/tools/Buffer.png";
// import FacebookAds from "../../../assets/tools/Facebook-Ads.jpg";
// import GoogleAds from "../../../assets/tools/Google-Ads.jpg";
// import GoogleAnalytics from "../../../assets/tools/Google-Analytics.jpg";
// import GoogleConsole from "../../../assets/tools/Google-Search-Console.jpg";
// import Grammarly from "../../../assets/tools/Grammarly.png";
// import HootSuite from "../../../assets/tools/HootSuite.png";
// import MailChimp from "../../../assets/tools/MailChimp.jpg";
// import Shopify from "../../../assets/tools/Shopify.webp";
// import Spyfu from "../../../assets/tools/Spyfu.jpg";
// import TwitterAds from "../../../assets/tools/Twitter-Ads.jpg";

import one from "../../../assets/partners/1.jpg";
import two from "../../../assets/partners/2.jpg";
import three from "../../../assets/partners/3.jpg";
import four from "../../../assets/partners/4.jpg";
import five from "../../../assets/partners/5.jpg";
import six from "../../../assets/partners/6.jpg";
import seven from "../../../assets/partners/7.jpg";

import PartnersSlider from "./PartnersSlider";

import partner from "../../../assets/partner.webp";
import { useTranslation } from "react-i18next";

const logos = [one, two, three, four, five, six, seven];

function Partners() {
  const { t } = useTranslation();

  return (
    <div className={classes.partnersDiv}>
      <h3>{t("Our Partners.mainTitle")}</h3>
      <p>{t("Our Partners.text1")}</p>
      {/* <hr width="10%" color="#012d36" size="8" align="left" /> */}

      <div className={classes.partnersSlider}>
        {/* <PartnersSlider logos={logos} /> */}

        <div className="row align-items-center">
          <div className={`col-md-5 ${classes.imgDiv}`}>
            <img src={partner} alt="partner-logo" />
          </div>
          <div className="col-md-7">
            <p>{t("Our Partners.text2")}</p>
          </div>
        </div>
      </div>

      {/* <hr /> */}
    </div>
  );
}

export default Partners;
